export const GalleryCard = ({ artwork, onClick }) => (
  <div
    className="gallery-card group relative overflow-hidden rounded-lg cursor-pointer bg-[var(--card)] border border-[var(--border)] transition-transform duration-300 hover:scale-[1.02]"
    onClick={() => onClick(artwork)}
  >
    <div className="aspect-[4/3] overflow-hidden">
      <img
        src={artwork.file}
        alt={artwork.title}
        loading="lazy"
        decoding="async"
        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
      />
    </div>
    
    <div className="absolute inset-0 flex flex-col justify-end p-4 transition-opacity duration-300 opacity-0 bg-gradient-to-t from-black/80 via-transparent to-transparent group-hover:opacity-100">
      <h3 className="text-lg font-bold text-white transition-transform duration-300 translate-y-4 font-syne group-hover:translate-y-0">
        {artwork.title}
      </h3>
      <p className="text-sm transition-transform duration-300 delay-75 translate-y-4 text-white/70 group-hover:translate-y-0">
        {artwork.artist}
      </p>
    </div>
    
    <div className="absolute px-2 py-1 text-xs font-medium transition-opacity rounded opacity-0 top-2 right-2 bg-black/50 text-white/80 group-hover:opacity-100">
      {artwork.watermark}
    </div>
  </div>
);